import styled from "styled-components";

export const AboutStyled = styled.div`
    color: var(--color-white);

    background: var(--color-darkNight);
`;
